// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "gallery/" + chunkId + "." + {"229":"b651ecb7","452":"85391aea","604":"f9bb3796","654":"98d445d4","718":"907ac880"}[chunkId] + ".chunk.js";
};